import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0034',
    ecrans: ['00-2']
});
